import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';

export const CrisisSupportBox = styled(Box, {
  dynamic: ({ cssProps: { displayCarousel } = {} }) => ({
    marginBottom: displayCarousel ? '' : '16px',
  }),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '8px',
  position: 'relative',
  flex: '1 0 0',
  padding: '0',
  alignSelf: 'stretch',
});

export const CrisisSupportIconContainer = styled('div', {
  zIndex: '1',
  position: 'absolute',
  bottom: '0px',
  height: '100% !important',
  alignContent: 'center',
  justifyContent: 'center',
  '@media (max-width: 464px)': {
    bottom: '0px',
    height: '100% !important',
  },
  variants: {
    isGeha: {
      true: {
        right: '12px',
      },
      false: {
        right: '4px',
      },
    },
  },
});

export const crisisSupportCardContentStyle = (isGEHAV2) => ({
  color: isGEHAV2 ? '$core.color.brand.100' : '#323333',
  fontSize: '$md',
  fontWeight: '400',
  fontStyle: '$core.color.neutral.100',
  textAlign: 'left',
  lineHeight: '20px',
  width: '100%',
  '@media (max-width: 464px)': {
    fontSize: '$sm',
    lineHeight: '18px',
  },
});

export const crisisSupportCardStyle = {
  width: '384px',
  height: '100%',
  minWidth: '144px',
  padding: '0px',
  '@media (max-width: 464px)': {
    width: '311px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
};

export const crisisSupportCardContainerStyle = {
  'abyss-flex-root': {
    display: 'flex',
    maxWidth: '284px',
    flexDirection: 'column',
    flexWrap: 'wrap',
    height: '100%',
    justifyContent: 'space-evenly',
    padding: '16px',
    '@media (max-width: 464px)': {
      width: '80%',
      maxWidth: '209px',
    },
  },
};

export const CrisisSupportCardCta = styled('div', {
  fontSize: '$md',
  lineHeight: '20px',
  display: 'block',
  marginTop: '10px',
  fontWeight: 'bold',
  color: '$core.color.brand.60',
  '& > span': {
    color: '$core.color.neutral.90',
    fontWeight: 400,
  },
  '@media (max-width: 464px)': {
    fontSize: '$sm',
    lineHeight: '18px',
  },
});
